/*
 * QRCode Messages
 *
 * This contains all the strings for the QRCode component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Title of the QR Code image popup
  title: 'QR code',
  // Close button label
  closeButtonLabel: 'Done',
  // Button label
  buttonLabel: 'Scan QR code',
});
